import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';

class za_StaticFeed extends PreLoginPage {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
	  // this.getLiveFeedData();
  }

  componentWillMount(){
	//this.getLiveFeedData();
  }
  render() {	
  	return(
  		<section className=''>
		 	<div className="container staticfeed"> 
		 	 	<div className="row scorecardLessons text-center padd">
						
								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={'./images/icons/education.png'} /><br/>
			    		  <span>5,000</span>
						 
						  </div>
						  <div className="card-body card-text">	
							<div>{this.rb("staticfeed.teacher")}</div>
			      	  </div> 
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={'./images/icons/pencil.png'} /><br/>
			    		  <span>1,000,000</span>
						  </div> 
						  <div className="card-body card-text">	
							<div>{this.rb("staticfeed.student")}</div>
			      	  </div> 
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={'./images/icons/diploma.png'} /><br/>
			    		  <span>30%</span>
						  </div> 
						  <div className="card-body card-text">	
		    				<div>{this.rb("staticfeed.improveInfo")}</div>
			      	  </div> 
							
								</div>

								<div className="col-sm-6 col-md-3">
								<div className="text-center">
								<img className="performicon" height="35px" src={'./images/icons/studentinfo.png'} /><br/>
			    		  <span style={{}}>92%</span>
						 
						  </div>
						  <div className="card-body card-text">	
		    				<div>{this.rb("staticfeed.studentsInfo")}</div>
			      	  </div> 
							
								</div>
								
				</div>
		 	 </div> 
		</section>
  	);
  }
}

export default za_StaticFeed;


// WEBPACK FOOTER //
// ./src/views/za/za_StaticFeed.js